import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getTodoChecklistRequest: null,
  getTodoChecklistSuccess: ['response'],
  getTodoChecklistFailure: null,

  submitTodoChecklistRequest: ['checklistId', 'payload'],
  submitTodoChecklistSuccess: ['response'],
  submitTodoChecklistFailure: ['checklistId'],

  updateChecklistCommentRequest: ['commentId', 'payload'],
  updateChecklistCommentSuccess: ['response'],
  updateChecklistCommentFailure: ['commentId'],

  deleteChecklistCommentRequest: ['commentId'],
  deleteChecklistCommentSuccess: ['commentId'],
  deleteChecklistCommentFailure: ['commentId'],

  getUsersCustomCommissionsRequest: null,
  getUsersCustomCommissionsSuccess: ['response'],
  getUsersCustomCommissionsFailure: null,

  approveCustomCommissionRequest: ['commissionId'],
  approveCustomCommissionSuccess: ['commissionId'],
  approveCustomCommissionFailure: ['commissionId'],

  declineCustomCommissionRequest: ['commissionId'],
  declineCustomCommissionSuccess: ['commissionId'],
  declineCustomCommissionFailure: ['commissionId'],

  getTodoListWithFilterRequest: ['column', 'value'],

  // Clear all caches
  clearTodoListRequest: null,
});

export const TodoListTypes = Types;
export default Creators;
